import { render, staticRenderFns } from "./TaskPlot.vue?vue&type=template&id=405965a4&scoped=true&"
import script from "./TaskPlot.vue?vue&type=script&lang=ts&"
export * from "./TaskPlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405965a4",
  null
  
)

export default component.exports